export default {
	data () {
		return {
			actionFullDates: {
				/*
				current: {
					start: null,
					end: null,
				},
				registration: {
					start: null,
					end: null,
				},
				participation: {
					start: null,
					end: null,
				},
				reparticipation: {
					start: null,
					end: null,
				}
				*/
			},
		}
	},
	methods: {


		addSixWeeksTo(date){
			/* Add 6 weeks to compensate the difference between Production en Acceptance */
			/* ! Use only for display */
			let delay = 6 * 7 * 24 * 60 * 60 * 1000; /* 6 weeks of 7 days of 24 hours of 60 minutes of 60 secondes of 1000 ms */
			return new Date(date.getTime() + delay);
		},


		/* GET ALL DATES USEFUL FOR THIS ACTIONS */
		/* Returns an object with many properties: startFullData, endFullData, currentDate */
		getFullDates(){

			let dates = {
				current: new Date(),
				registration:{
					start:  new Date(this.lead.registrationbegindate),
					end:  new Date(this.lead.registrationenddate),
				},
				participation: {
					start: new Date(this.lead.participationbegindate),
					end:  new Date(this.lead.participationextensiondate),
				},
				reparticipation: {
					start:  new Date(this.lead.participationbegindate),
					end:  new Date(this.lead.treatmentenddaterepart),
				},
				purchaseDates: {
					start: new Date(this.lead.purchasebegindate),
					end: new Date(this.lead.purchaseenddate),
				}
			};

			/* Adapt dates for correct timing */
			this.log("Dates correction check", 'group');
			dates.registration.end = this.correctionDate('registrationenddate');
			dates.participation.end = this.correctionDate('participationextensiondate');
			dates.reparticipation.end = this.correctionDate('treatmentenddaterepart');
			dates.purchaseDates.end = this.correctionDate('purchaseenddate');
			this.log("", 'groupEnd');
			/* Display for control */
			this.log('Dates techniques', 'group');
			this.log(dates);
			this.log('', 'groupEnd');
			return dates;
		},

		applyCorrectionToDate(wrongDate){
			// We add 23h59m59s because registration and (re)participation close at the END of the day 
			let hours = 23 * 60 * 60;
			let minutes = 59 * 60;
			let seconds = 59;
			let almostADayDuration = (hours + minutes + seconds) * 1000;
			let wrongTime = new Date(wrongDate).getTime();
			return new Date(wrongTime + almostADayDuration);
		},

		/* Temporary correction for new formatDate, to be sure PRODUCTION actions ends at the right time */
		correctionDate(labelDate){
			this.log(`Eval of ${labelDate}: date is "${this.lead[labelDate]}"`);
			// check if correction already exists
			if(this.lead[labelDate].length > 10){
				this.log("Date has the new format => nothing to do", 'green');
				return new Date(this.lead[labelDate]);
			}else{
				this.log("Date has the wrong format => correction", 'red');
				let correction = this.applyCorrectionToDate(this.lead[labelDate]);
				this.log(`Corrected to: ${this.getHumanReadableDate(correction)}`);
				return correction; // already a Date object
			}
		},

		/* DISPLAY THE DATES IN THE CONSOLE */
		/* For CONSOLE INFO only */
		displayDatesInConsole(){
			this.log("Human-readable dates for this action", "sep");
			try{
				console.group("Human-readable dates for this action");
				console.log("Current:                       %c " + this.getHumanReadableDate(this.actionFullDates.current), 'color:#0000cc;');
				console.log("Registration opens on:         %c " + this.getHumanReadableDate(this.actionFullDates.registration.start), 'color:#0000cc;');
				console.log("Registration closes on:        %c " + this.getHumanReadableDate(this.actionFullDates.registration.end), 'color:#0000cc;');
				console.log("Participation opens on:        %c " + this.getHumanReadableDate(this.actionFullDates.participation.start), 'color:#0000cc;');
				console.log("Participations closes on:      %c " + this.getHumanReadableDate(this.actionFullDates.participation.end), 'color:#0000cc;');   
				console.log("Reparticipations closes on:    %c " + this.getHumanReadableDate(this.actionFullDates.reparticipation.end), 'color:#0000cc;');            
				console.groupEnd();
			}catch(error){
				this.log(error, "alert");
			}
		},

		/* FORMAT DATE SO HUMANS CAN EASILY READ THEM */
		getHumanReadableDate(isoDate){
			let humanReadableStartDate = isoDate.toLocaleDateString("fr-BE", {
				year: "numeric",
				month: "2-digit",
				day: "2-digit",
				hour: "2-digit", 
				minute: "2-digit", 
				second: "2-digit"
			});
			return humanReadableStartDate;
		},
		
		/* User is too soon/late for registration or participation: he cannot enter the form */ 
		/* CONDITIONS => Must return true or false */
		isUserThereTooSoon () {
			return this.actionFullDates.current.getTime() < this.actionFullDates.registration.start.getTime();
		},
		isUserThereTooLate () {
			return this.actionFullDates.current.getTime() > this.actionFullDates.participation.end.getTime();
		},
		isUserAbleToReparticipate() {
			return this.actionFullDates.current.getTime() > this.actionFullDates.participation.end.getTime() &&
			this.actionFullDates.current.getTime() < this.actionFullDates.reparticipation.end.getTime();
		},



		checkRegistrationDates(){
			/* Too soon for registration */
			if ( this.actionFullDates.current.getTime() < this.actionFullDates.registration.start.getTime() )	{
				this.goto('beforeStart');
			}
			/*  Too late for registration */
			if ( this.actionFullDates.current.getTime() > this.actionFullDates.registration.end.getTime() ){
				this.goto('actionEnded'); 
			}
			/* Time ok for registration */
			if (	this.actionFullDates.current.getTime() > this.actionFullDates.registration.start.getTime() && 
				this.actionFullDates.current.getTime() < this.actionFullDates.registration.end.getTime() ) 
			{
				this.goto('registration');
			}
		},
		
		checkParticipationDates(){
			/* Too soon for participation */
			if ( this.actionFullDates.current.getTime() < this.actionFullDates.participation.start.getTime() ){
				this.goto('beforeStart');
			}
			/* Too late for participation */
			if ( this.actionFullDates.current.getTime() > this.actionFullDates.participation.end.getTime() ){
				this.goto('actionEnded');
			}
			/* Time ok for participation */
			if ( 
				this.actionFullDates.current.getTime() > this.actionFullDates.participation.start.getTime() && 
				this.actionFullDates.current.getTime() < this.actionFullDates.participation.end.getTime() )
			{
				this.putDataInFields();
				this.justBeforeLoadingTheFormPage();
			}
		},

		checkReparticipationDates(){
			if (this.actionFullDates.current.getTime() < this.actionFullDates.participation.start.getTime() ) {
				/* never occurs, as it cannot exist a reparticipation state if there is no participation. But nevertheless… */
				this.goto('beforeStart');
			}
			if ( this.actionFullDates.current.getTime() >= this.actionFullDates.reparticipation.end.getTime() ) {
				this.goto('actionEnded');
			}
			if ( this.actionFullDates.current.getTime() >= this.actionFullDates.participation.start.getTime() &&
				this.actionFullDates.current.getTime() < this.actionFullDates.reparticipation.end.getTime()
				) {
				this.putDataInFields();
			
			this.justBeforeLoadingTheFormPage();
		}
	},

},
computed: {

},

}